/** @jsxImportSource minimal-view */

import { element, view, web } from 'minimal-view'
import { skin } from './skin'
import { Sound } from './api'
import { app } from './app'
import { Plot } from './plot'
import { PLOT_HEIGHT_PX, PLOT_WIDTH_PX } from './constants'
import { screen } from './screen'
import { hmr } from './hmr'
import { PFFT } from 'pretty-fast-fft'

export type SoundView = typeof SoundView.State

export const SoundView = hmr(web(view('sound-view',
  class props {
    sound!: Sound
    analyser!: PFFT
  },
  class local {
    host = element
    plot?: Plot
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
    })
  },
  function effects({ $, fx, deps, refs }) {
    fx(() => skin.fx(({ fonts, colors }) => {
      $.css = /*css*/`
      & {
      }

      canvas {
        width: 100%;
      }
      `
    }))

    fx(({ analyser }) => {
      $.plot = new Plot(analyser)
    })

    fx(({ plot }) => {
      plot.resize(
        PLOT_WIDTH_PX,
        PLOT_HEIGHT_PX * 0.5,
        screen.$.pr
      )
    })

    fx(async ({ plot, sound }) => {
      try {
        const floats = await app.$.createPreview(sound)
        plot.clear()
        plot.draw(floats[0])
      } catch (error) {
        console.warn(error)
      }
    })

    fx(({ plot }) => {
      $.view = <canvas
        ref={{
          get current() {
            return plot.canvas
          }
        }}
      />
    })
  }
)))
